export const play = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.394 7.56574L2 3.30274V11.8287L8.394 7.56574ZM11.376 7.98174L0.777 15.0477C0.701706 15.0978 0.61423 15.1266 0.523891 15.1309C0.433553 15.1352 0.343733 15.115 0.263999 15.0723C0.184265 15.0296 0.117604 14.9661 0.0711136 14.8885C0.0246236 14.8109 4.67204e-05 14.7222 0 14.6317V0.499742C4.67204e-05 0.4093 0.0246236 0.320564 0.0711136 0.242985C0.117604 0.165406 0.184265 0.10189 0.263999 0.0592012C0.343733 0.0165124 0.433553 -0.00375036 0.523891 0.000571232C0.61423 0.00489283 0.701706 0.0336371 0.777 0.0837421L11.376 7.14974C11.4445 7.1954 11.5006 7.25726 11.5395 7.32983C11.5783 7.4024 11.5986 7.48344 11.5986 7.56574C11.5986 7.64805 11.5783 7.72908 11.5395 7.80165C11.5006 7.87422 11.4445 7.93608 11.376 7.98174Z"
        fill="currentColor"
      />
    </svg>
  );
};